import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class ConnectorFields {
  public static controls = {
    title: {
      quantity: null,
      validator: TERMS.NAMES_VALIDATORS,
    },
    length: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    externalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    internalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    morisonInertia: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    morisonDrag: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    weightDry: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    weightWet: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.SCI_NOTATION,
    },
    stiffAxial: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    stiffTorsional: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    stiffBending: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    youngModulus: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
  };
}
